import React from 'react';
import { Container } from '@mui/material';
import { HeroSection, ContentWrapper, HeroTitle, HeroSubtitle, CTAButton, ScrollDownIcon } from '../styles/HeroStyles';
import { useHero } from '../utils/HeroUtils';

const HeroComp = () => {
  const { title, subtitle, cvHref, cvDownloadName } = useHero();

  return (
    <HeroSection id="home">
      <Container maxWidth="md">
        <ContentWrapper>
          <HeroTitle variant="h1">{title}</HeroTitle>
          <HeroSubtitle variant="h5">{subtitle}</HeroSubtitle>
          <CTAButton
            variant="contained"
            color="secondary"
            size="large"
            component="a"
            href={cvHref}
            download={cvDownloadName}
          >
            Download CV
          </CTAButton>
        </ContentWrapper>
      </Container>
      <ScrollDownIcon />
    </HeroSection>
  );
};

export default HeroComp;
